export default __webpack_public_path__ + "static/media/james_thumb.cfb58f21.jpg";